import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSettingsState } from '../../context/SettingsContext';
import { useTranslation } from 'react-i18next';
import affideaWhiteLogo from '../../../assets/images/affidea-logo-white-main.png';
import { Ripple } from 'primereact/ripple';
import { useUserDispatch, useUserState } from '../../context/UserContext';
import { RiFileUserFill, RiLogoutBoxRLine } from 'react-icons/ri';
import { FaUserCircle } from 'react-icons/fa';
import MobileSidebar from './MobileSidebar';

const HeaderNav = (props) => {
  const { header } = useSettingsState();
  const userState = useUserState();
  const sessionDispatch = useUserDispatch();
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isLoggedIn, setIsloggedIn] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setIsloggedIn(userState?.isLoggedIn);
  }, [userState]);

  const handleLogout = async () => {
    sessionDispatch({ type: 'LOGOUT' });
    closeMenu();
  };

  const closeMenu = () => {
    setIsMobileMenuOpen(false);
    setIsDropdownOpen(false);
  };

  const getUsersName = () => {
    const usersName = `${userState?.firstName} ${userState?.lastName?.charAt(
      0,
    )}.`;
    return usersName;
  };

  const NAV_ITEMS = [
    { label: 'header.aboutLabel', url: header.about?.url },
    { label: 'header.servicesLabel', url: header.services?.url },
    { label: 'header.findUsLabel', url: header.findUs?.url },
    { label: 'header.ourDoctorsLabel', url: header.ourDoctors?.url },
    { label: 'header.pricesLabel', url: header.prices?.url },
    { label: 'header.becomePatientLabel', url: '/transfer-request' },
    { label: 'header.registration', url: '/' },
  ];

  return (
    <>
      <header className="bg-affidea-dark-blue h-16 flex items-center px-4 sm:px-6 fixed top-0 left-0 w-full z-50 shadow-sm shadow-gray-500 font-primary font-light text-xs">
        <Link to="/" className="flex-shrink-0 flex items-center h-full">
          <img
            src={affideaWhiteLogo}
            alt="Affidea white logo"
            className="h-6 lg:h-8 max-h-full"
          />
        </Link>

        <div className="flex-1 lg:hidden" />

        {/* Mobile Menu Toggle Button */}
        <div
          className="lg:hidden text-white order-1 focus:outline-none ml-auto w-10 h-10 flex items-center justify-center rounded-full bg-affidea-dark-blue hover:bg-affidea-dark-blue-hover transition p-ripple"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle Menu"
        >
          <div className="text-xl">{isMobileMenuOpen ? '✖' : '☰'}</div>
          <Ripple />
        </div>

        {/* Mobile Sidebar Menu */}
        {isMobileMenuOpen && (
          <div className="absolute top-full right-0 w-3xs bg-white shadow-lg lg:hidden z-40 border border-gray-200 text-base h-[calc(100vh-4rem)] overflow-y-auto">
            <nav className="flex flex-col space-y-0 text-gray-900 font-normal">
              {/* ✅ User Info */}
              {isLoggedIn && (
                <>
                  <div className="p-4 border-b border-gray-200 bg-gray-100 font-medium text-blue-800">
                    <div className="flex items-center space-x-2">
                      <FaUserCircle className="text-2xl" />
                      <span>{getUsersName()}</span>
                    </div>
                  </div>

                  <Link
                    to={{ pathname: '/useraccount', state: { isDirect: true } }}
                    onClick={closeMenu}
                  >
                    <div className="p-4 border-b border-gray-200 cursor-pointer hover:bg-blue-100 transition text-blue-800">
                      <div className="flex items-center space-x-2">
                        <RiFileUserFill className="text-2xl" />
                        <span>{t('header.selfService.account')}</span>
                      </div>
                    </div>
                  </Link>

                  <Link to="/" onClick={handleLogout}>
                    <div className="p-4 border-b border-gray-200 cursor-pointer hover:bg-blue-100 transition text-blue-800">
                      <div className="flex items-center space-x-2">
                        <RiLogoutBoxRLine className="text-2xl" />
                        <span>{t('userAccount.sidebar.logout')}</span>
                      </div>
                    </div>
                  </Link>
                </>
              )}

              {/* ✅ NAV_ITEMS */}
              {NAV_ITEMS.map((item, index) => (
                <div
                  key={index}
                  className="border-b p-2 border-gray-200 cursor-pointer hover:bg-blue-100 transition"
                  onClick={() => (window.location.href = item.url)}
                >
                  <span className="block w-full h-full">
                    {t(item.label).replace('<a>', '').replace('</a>', '')}
                  </span>
                </div>
              ))}

              {/* ✅ Your MobileSidebar component here */}
              {/* {isLoggedIn && (
                <MobileSidebar
                  userState={userState}
                  closeMenu={closeMenu}
                  handleLogout={handleLogout}
                  renderSubMenu={() => null} // Optional, replace if needed
                  t={t}
                />
              )} */}
            </nav>
          </div>
        )}

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex flex-1 justify-start text-white font-medium ml-4 h-12 px-3">
          {NAV_ITEMS.map((item, index) => (
            <div
              key={index}
              className="h-12 px-3 rounded-[5px] flex items-center transition duration-300 cursor-pointer hover:bg-affidea-dark-blue-hover p-ripple"
              onClick={() => (window.location.href = item.url)}
            >
              {t(item.label)
                .replace('<a>', '')
                .replace('</a>', '')
                .toUpperCase()}
              <Ripple />
            </div>
          ))}
        </nav>

        {/* Login button */}
        {!isLoggedIn && (
          <Link to="/selfservice">
            <div className="flex order-1 bg-affidea-green hover:bg-affidea-green-hover text-white px-6 py-2 items-center justify-center font-medium rounded-4xl transition p-ripple">
              {t('header.selfService.login').toUpperCase()}
              <Ripple />
            </div>
          </Link>
        )}

        {/* User dropdown (desktop) */}
        {isLoggedIn && (
          <div className="relative lg:block hidden" ref={dropdownRef}>
            <button
              className="bg-blue-900 hover:bg-blue-600 text-white px-6 py-2 items-center justify-center font-medium rounded-md flex"
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
            >
              {getUsersName()}
              <span className="ml-2 text-white">
                {isDropdownOpen ? '▼' : '▲'}
              </span>
            </button>

            {isDropdownOpen && (
              <div className="absolute right-0 top-full mt-2 bg-white shadow-lg rounded-xs w-44 z-50 border border-gray-200 font-medium">
                <div className="text-blue-900 py-2">
                  <Link
                    to={{ pathname: '/useraccount', state: { isDirect: true } }}
                    onClick={closeMenu}
                  >
                    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer rounded-xs">
                      <div className="flex items-center space-x-2 text-sm">
                        <RiFileUserFill />
                        <span>{t('header.selfService.account')}</span>
                      </div>
                    </div>
                  </Link>

                  <Link to="/" onClick={handleLogout}>
                    <div className="px-4 py-2 hover:bg-gray-100 cursor-pointer rounded-xs">
                      <div className="flex items-center space-x-2 text-sm">
                        <RiLogoutBoxRLine />
                        <span>{t('userAccount.sidebar.logout')}</span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            )}
          </div>
        )}
      </header>
    </>
  );
};

export default HeaderNav;
